import { render } from "./footer.vue?vue&type=template&id=e74d6058&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=e74d6058&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e74d6058"

export default script